module.exports = __webpack_public_path__ + "files/af50a5909d4377acf196f3e7da6bbb38.svg";